export default "<p>commons works!</p>\n"